import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-tr-new-job-select-op',
  templateUrl: './tr-new-job-select-op.component.html',
  styleUrls: ['./tr-new-job-select-op.component.css']
})
export class TrNewJobSelectOpComponent implements OnInit {
    labourNo;

    public selectedBgOperationTrListSelection: string = '0';

    public itemsListOperations: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
    }

    private async loadOperations() {
        if (!!this.labourNo && !!this.selectedBgOperationTrListSelection)
        this.itemsListOperations = await this.datatask.Post(124, {
            labour_no: this.labourNo,
            direct: this.selectedBgOperationTrListSelection
        });
    }

    public onTabChanged() {
        this.loadOperations();
    }

    private async init() {
        this.loadOperations();
    }

    ngOnInit() {
        this.init();
    }
}
